import { render, staticRenderFns } from "./StickyCombined.vue?vue&type=template&id=48d926c6"
import script from "./StickyCombined.vue?vue&type=script&lang=js"
export * from "./StickyCombined.vue?vue&type=script&lang=js"
import style0 from "./StickyCombined.vue?vue&type=style&index=0&id=48d926c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports